import { Avenant } from "../models/avenant";
import { RequestBodyContext } from "../models/request-body-context";

export class RequestBodyContextBuilder {
  private requestBody: RequestBodyContext = {
    codeReseau: null,
    codeOperation: "DROIT_CREATE_DEVIS",
    idVendeur: 0,
    modeConnexion: "APP",
    idGestionaire: 0,
    referenceDevis: null,
    produit: "",
    branche: "",
    souscripteur: {
      civilite: 1,
      prenom: null,
      nom: null,
      dateNaissance: null,
      paysNaissance: null,
      departementNaissance: null,
      villeNaissance: null,
      adresse: null,
      adresse2: null,
      codePostal: null,
      ville: null,
      telephone: null,
      email: null,
      profil: null,
      typologieSouscripteur: "P",
    },
    codeVendeur: null,
    nomVendeur: null,
    prenomVendeur: null,
    siteVendeur: "000001",
    canalVente: "W",
    referenceContrat: null,
    typeContact: null,
    donneesPartenaire: null,
    avenants: [],
  };

  setReferenceDevis(referenceDevis: string | null) {
    this.requestBody.referenceDevis = referenceDevis;
    return this;
  }

  setProduit(produit: string) {
    if (!produit) {
      throw new Error("Le produit est requis.");
    }
    this.requestBody.produit = produit;
    return this;
  }

  setCiviliteType(civiliteType: number) {
    this.requestBody.souscripteur.civilite = civiliteType;
    return this;
  }

  setPrenomSouscripteur(prenom: string | null) {
    this.requestBody.souscripteur.prenom = prenom;
    return this;
  }

  setNomSouscripteur(nom: string | null) {
    this.requestBody.souscripteur.nom = nom;
    return this;
  }

  setDateNaissance(dateNaissance: Date | null) {
    this.requestBody.souscripteur.dateNaissance = dateNaissance;
    return this;
  }

  setPaysNaissance(paysNaissance: string | null) {
    this.requestBody.souscripteur.paysNaissance = paysNaissance;
    return this;
  }

  setDepartementNaissance(departementNaissance: string | null) {
    this.requestBody.souscripteur.departementNaissance = departementNaissance;
    return this;
  }

  setVilleNaissance(villeNaissance: string | null) {
    this.requestBody.souscripteur.villeNaissance = villeNaissance;
    return this;
  }

  setTelephone(telephone: string | null) {
    this.requestBody.souscripteur.telephone = telephone;
    return this;
  }

  setEmail(email: string | null) {
    this.requestBody.souscripteur.email = email;
    return this;
  }

  setCodeVendeur(codeVendeur: string | null) {
    this.requestBody.codeVendeur = codeVendeur;
    return this;
  }

  setReferenceContrat(referenceContrat: string | null) {
    this.requestBody.referenceContrat = referenceContrat;
    return this;
  }

  setBranche(branche: string) {
    this.requestBody.branche = branche;
    return this;
  }

  setAvenants(avenants: Avenant[]) {
    this.requestBody.avenants = avenants;
    return this;
  }

  build(): RequestBodyContext {
    return this.requestBody;
  }
}
